import { apiClient, handleResp } from './utils';

export default {
  doAddSubcription(data) {
    return handleResp(apiClient().post('/add_subscription', data));
  },
};
